"use strict";

angular.module("core")
.service("ProfileService", function(
    $resource, $http, appConfig
) {
    var profileUpdateResource = $resource(appConfig.API_SERVER + "/auth/profile/");

    this.getProfile = function() {
        return profileUpdateResource.get();
    };

    this.saveProfile = function(fromData) {
        return fromData.$save();
    };

    this.deleteProfile = function(password) {
        return $http.delete(appConfig.API_SERVER + "/auth/profile/", {
                data: {password: password},
                headers: {'Content-Type' : 'application/json'}
            }
        );
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/profile/profile.service.js
// module id = 412
// module chunks = 0